import { render, staticRenderFns } from "./InputColorGroup.vue?vue&type=template&id=0abffa92&"
import script from "./InputColorGroup.vue?vue&type=script&lang=js&"
export * from "./InputColorGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports